import { cardsData } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20dramatic%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20historical%20drama%20movie%20poster%20style%2C%20rich%20golden%20and%20deep%20red%20tones%2C%20cinematic%20composition%2C%20epic%20scale&width=600&height=840&seq=card-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Intense%20crime%20drama%20scene%20with%20two%20figures%20facing%20off%20in%20a%20rainy%20urban%20alley%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20gritty%20realistic%20style%2C%20dark%20moody%20tones%20with%20warm%20accent%20lights%2C%20cinematic%20film%20poster%20aesthetic&width=600&height=840&seq=card-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20village%20in%20Yunnan%20China%20with%20rolling%20green%20hills%20and%20traditional%20wooden%20houses%2C%20soft%20golden%20sunlight%2C%20healing%20pastoral%20atmosphere%2C%20warm%20natural%20tones%2C%20gentle%20breeze%20through%20wildflowers%2C%20cinematic%20wide%20shot&width=600&height=840&seq=card-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20massive%20alien%20structure%20looming%20over%20a%20modern%20city%2C%20cosmic%20background%20with%20stars%2C%20dramatic%20contrast%20lighting%2C%20deep%20space%20and%20warm%20earth%20tones%2C%20epic%20scale%2C%20cinematic%20movie%20poster%20style&width=600&height=840&seq=card-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20scene%20with%20floating%20islands%20and%20ancient%20Chinese%20palace%20in%20the%20clouds%2C%20ethereal%20mist%20and%20soft%20moonlight%2C%20cherry%20blossom%20petals%20drifting%2C%20dreamy%20pink%20and%20gold%20tones%2C%20cinematic%20composition%2C%20fairy%20tale%20aesthetic&width=600&height=840&seq=card-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Small%20northern%20Chinese%20industrial%20town%20in%20autumn%20with%20yellow%20leaves%20and%20old%20factory%20buildings%2C%20melancholic%20atmosphere%2C%20golden%20hour%20lighting%2C%20nostalgic%20and%20mysterious%20mood%2C%20cinematic%20wide%20composition%2C%20rich%20warm%20amber%20tones&width=600&height=840&seq=card-06&orientation=portrait',
];

const cardItems = cardsData.map((item, i) => ({ ...item, img: cardImages[i] }));

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热播推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">高分好剧 · 一网打尽</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {cardItems.map((item, index) => (
            <article
              key={index}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={item.img}
                  alt={`天狼影院 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute top-2 left-2 flex items-center gap-1 px-1.5 py-0.5 bg-background-950/70 rounded text-xs">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-background-50 font-medium">{item.rating}</span>
                </div>
                <span className="absolute top-2 right-2 px-1.5 py-0.5 text-[10px] font-medium bg-background-50/90 text-foreground-700 rounded whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-xs md:text-sm font-semibold text-foreground-950 mb-1 truncate">
                  {item.title}
                </h3>
                <p className="text-[11px] md:text-xs text-foreground-500 leading-snug line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}